import React, { useState, useContext, useEffect } from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";


import { Paper, Button, Box, TextField, InputAdornment } from "@material-ui/core";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import SearchIcon from '@material-ui/icons/Search';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import MoreVertIcon from '@material-ui/icons/MoreVert';


// Icons
import { UserContext } from "../../contexts/UserContext";


const useStyles = makeStyles((theme) => ({
  compareRow: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  // heading: {
  // 	fontSize: theme.typography.pxToRem(15),
  // },
  // secondaryHeading: {
  // 	fontSize: theme.typography.pxToRem(15),
  // 	color: theme.palette.text.secondary,
  // },
  // icon: {
  // 	verticalAlign: "bottom",
  // 	height: 20,
  // 	width: 20,
  // 	marginRight: theme.spacing(2),
  // 	display: "inline-block",
  // },
  // details: {
  // 	alignItems: "center",
  // },
  // buttonIconLeft: {
  // 	marginRight: theme.spacing(1),
  // },
  searchField: {
    marginBottom: theme.spacing(2)
  }
}));

const ComparesList = (props) => {
  const theme = useTheme();
  const classes = useStyles();
  let history = useHistory();
  const userContext = useContext(UserContext);
  const [actionsMenuTarget, setActionsMenuTarget] = useState(null);
  const [compareForActions, setCompareForActions] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");


  const renderCompare = (compare) => {

    return <Paper key={compare.id} className={classes.compareRow}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={8} md={6}>
          <Typography className={classes.heading}>
            {compare.title}
          </Typography>
        </Grid>
        <Grid item xs={4} md={3}>
          <Typography variant="overline">
            {compare.user.name}
          </Typography>
        </Grid>
        <Grid item xs={6} md={2}>
          <Button size="small" onClick={() => {
            history.push("/kreditvergleich/" + compare.id);
          }}>
            öffnen
          </Button>
        </Grid>
        <Grid item xs={2} md={1}>
          <IconButton
            aria-label="more"
            aria-controls="compare-menu"
            aria-haspopup="true"
            onClick={(e) => {
              setActionsMenuTarget(e.currentTarget)
              setCompareForActions(compare)
            }}
          >
            <MoreVertIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Paper>;
  }

  if (props.compares.length === 0)
    return (
      <Paper className={classes.compareRow}>
        <Typography align="center">
          Hallo {userContext.user.name},<br />
          Diese Übersichtsseite wird all deine Kreditvergleiche enthalten.<br />
          Im Moment gibt es allerdings noch nichts zu sehen, also klick bitte rechts oben auf "Neuen Kreditvergleich anlegen" um los zu legen.
        </Typography>
      </Paper>
    )
  return (
    <div>
      <Box align="right">
        <TextField
          placeholder="Suchen"
          className={classes.searchField}
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
          }}
          InputProps={{
            endAdornment: <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>,
          }}
        />
      </Box>
      {
        props.compares.filter(compare => {
          if (searchTerm.length < 3)
            return true;

          // search in compare title and agent name first
          if (compare.title.toUpperCase()
            .includes(searchTerm.toUpperCase())
            || compare.user.name.toUpperCase()
              .includes(searchTerm.toUpperCase()))
            return true;

          // now go to metafields
          return compare.metafields.some(field => (
            (field.meta_key.endsWith('__vorname') || field.meta_key.endsWith('__nachname'))
            &&
            field.meta_value
            &&
            field.meta_value.toUpperCase()
              .includes(searchTerm.toUpperCase()
              )
          )
          );

        }).map((compare) => {
          return renderCompare(compare);
        })
      }
      <Menu
        id="compare-menu"
        anchorEl={actionsMenuTarget}
        keepMounted
        open={Boolean(actionsMenuTarget)}
        onClose={() => { setActionsMenuTarget(null) }}
      >
        <MenuItem onClick={() => {
          setActionsMenuTarget(null)
          props.deleteCompare(compareForActions)
        }}>
          <ListItemIcon>
            <DeleteForeverIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">löschen</Typography>
        </MenuItem>
      </Menu>
    </div>
  )
};

export default ComparesList;